import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
Vue.use(VueRouter)
//重复路由不报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err);
}
const routes = [
  {
    path: '/',
    redirect:"/Home"
  },
  {
    path: '/Home',
	redirect:"/Home/page",
    name: 'Home',
    component: Home,
	children:[
		{
		  path: '/Home/recommendation',
		  name: 'recommendation',
		  component: () => import(/* webpackChunkName: "about" */ '../views/recommendation.vue')
		},
		{
		  path: '/Home/page',
		  name: 'page',
		  component: () => import(/* webpackChunkName: "about" */ '../views/page.vue')
		},
		{
		  path: '/Home/character',
		  name: 'character',
		  component: () => import(/* webpackChunkName: "about" */ '../views/character.vue')
		},
		{
		  path: '/Home/Resource',
		  name: 'Resource',
		  component: () => import(/* webpackChunkName: "about" */ '../views/Resource.vue')
		},
		{
		  path: '/Home/college',
		  name: 'college',
		  component: () => import(/* webpackChunkName: "about" */ '../views/college.vue')
		},
		{
		  path: '/Home/collgetwo',
		  name: 'collgetwo',
		  component: () => import(/* webpackChunkName: "about" */ '../views/collgetwo.vue')
		},
		{
		  path: '/Home/collegethree',
		  name: 'collegethree',
		  component: () => import(/* webpackChunkName: "about" */ '../views/collegethree.vue')
		},
		{
		  path: '/Home/collegefour',
		  name: 'collegefour',
		  component: () => import(/* webpackChunkName: "about" */ '../views/collegefour.vue')
		},
		{
		  path: '/Home/cardiovascular',
		  name: 'cardiovascular',
		  component: () => import(/* webpackChunkName: "about" */ '../views/cardiovascular.vue')
		},
		{
		  path: '/Home/modify',
		  name: 'modify',
		  component: () => import(/* webpackChunkName: "about" */ '../views/modify.vue')
		}, 
		{
		  path: '/Home/Research',
          name: 'Research',
          component: () => import(/* webpackChunkName: "about" */ '../views/Research.vue')
        },
		{
		  path: '/Home/modifytwo',
		  name: 'modifytwo',
		  component: () => import(/* webpackChunkName: "about" */ '../views/modifytwo.vue')
		},
		{
		  path: '/Home/meeting',
		  name: 'meeting',
		  component: () => import(/* webpackChunkName: "about" */ '../views/meeting.vue')
		},
		{
		  path: '/Home/Business',
		  name: 'Business',
		  component: () => import(/* webpackChunkName: "about" */ '../views/Business.vue')
		},
		{
		  path: '/Home/new_file',
		  name: 'new_file',
		  component: () => import(/* webpackChunkName: "about" */ '../views/new_file.vue')
		},
		{
		  path: '/Home/about',
		  name: 'About',
		  // route level code-splitting
		  // this generates a separate chunk (about.[hash].js) for this route
		  // which is lazy-loaded when the route is visited.
		  component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
		},
		{
		  path: '/Home/my',
		  name: 'my',
		  component: () => import(/* webpackChunkName: "about" */ '../views/my.vue')
		},
		{
		  path: '/Home/sign',
		  name: 'sign',
		  component: () => import(/* webpackChunkName: "about" */ '../views/sign.vue')
		},
		{
		  path: '/Home/product',
		  name: 'product',
		  component: () => import(/* webpackChunkName: "about" */ '../views/product.vue')
		},
		{
		  path: '/Home/activity',
		  name: 'activity',
		  component: () => import(/* webpackChunkName: "about" */ '../views/activity.vue')
		},
		{
		  path: '/Home/details',
		  name: 'details',
		  component: () => import(/* webpackChunkName: "about" */ '../views/details.vue')
		},
		{
		  path: 'Home/detailthree',
		  name: 'detailthree',
		  // route level code-splitting
		  // this generates a separate chunk (about.[hash].js) for this route
		  // which is lazy-loaded when the route is visited.
		  component: () => import(/* webpackChunkName: "about" */ '../views/detailthree.vue')
		},
		{
		  path: '/detailstwo',
		  name: 'detailstwo',
		  component: () => import(/* webpackChunkName: "about" */ '../views/detailstwo.vue')
		},
	],
	
  },
  {
    path: '/picture',
    name: 'picture',
    component: () => import(/* webpackChunkName: "about" */ '../views/picture.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
